import { useBoundStore } from "../bound.store";
import type { BoundStore } from "../bound.store";

/** Whether the account belongs to any team. Unknown while the profile is unread, which counts as one. */
export const selectHasTeams = (state: BoundStore): boolean => state.profile?.organisations?.length !== 0;

export const useHasTeams = (): boolean => useBoundStore(selectHasTeams);
